// src/mocks/handlers.js
import { http } from "msw";
import { customResponse } from "../../../mocks/customResponse";
import { HTTP_CUSTOMER_PORTAL } from "../../enums/httpEnum";
import { mockTripData } from "../../../tests/mockData/trips/tripList";

export const mockTripHandlers = [
  /**
   * Handler for fetch mock trip list data
   */
  http.get(HTTP_CUSTOMER_PORTAL.FETCH_TRIP_LIST, async () => {
    return customResponse({ data: mockTripData });
  })
];
